import { render, staticRenderFns } from "./UserTabs.vue?vue&type=template&id=03feb1ea&"
import script from "./UserTabs.vue?vue&type=script&lang=ts&"
export * from "./UserTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports